import React from 'react';
import { books } from '../data/books';

/**
 * schema.org data for the offer on this page. The purchase-notification
 * scanner reads this first, so toasts always show real products and prices.
 */
export function ProductStructuredData() {
  const data = {
    '@context': 'https://schema.org',
    '@graph': [{
      '@type': 'Product',
      name: 'Bundle Conexión Real — 5 Ebooks',
      bookEdition: 'Edición Digital · 5 Ebooks',
      description: 'Los 5 ebooks sobre atracción, seducción, lenguaje corporal, primeras citas y conversación real.',
      image: books[0].cover,
      offers: {
        '@type': 'Offer',
        name: 'Bundle Completo · Edición Digital',
        price: 9.99,
        priceCurrency: 'USD',
        availability: 'https://schema.org/InStock'
      }
    }, ...books.map(book => ({
      '@type': 'Product',
      name: book.title,
      bookEdition: `Volumen ${book.volume} · Edición Digital`,
      image: book.cover,
      offers: {
        '@type': 'Offer',
        name: `Volumen ${book.volume} · Edición Digital`,
        price: Number.parseFloat(book.value.replace('$', '')),
        priceCurrency: 'USD',
        availability: 'https://schema.org/InStock'
      }
    }))]
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{
    __html: JSON.stringify(data)
  }} data-id="element-206" data-mp="20en3f1er7fbl" />;
}